import { render, staticRenderFns } from "./ShrinkageTab.vue?vue&type=template&id=1707d051&scoped=true"
import script from "./ShrinkageTab.vue?vue&type=script&lang=js"
export * from "./ShrinkageTab.vue?vue&type=script&lang=js"
import style0 from "./ShrinkageTab.vue?vue&type=style&index=0&id=1707d051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707d051",
  null
  
)

export default component.exports